

















































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import ITimeTrackingRecord from "@/models/TimeTracking/ITimeTrackingRecord";
import Level from "@/components/Level/Level.vue";
import LevelItem from "@/components/Level/LevelItem.vue";

import AppConfig from "@/config/AppConfig";
import StopTimeTrackingRecordModal from "@/views/Service/TimeTracking/Modals/StopTimeTrackingRecordModal.vue";
import SelfUpdatingTimeDiff from "@/components/SelfUpdatingTimeDiff/SelfUpdatingTimeDiff.vue";
import Tag from "@/components/common/Tags/Tag.vue";
import JsonResource from "@/components/common/Debug/JsonResource.vue";

const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';

const RESOURCE_TIME_TRACKING_RECORD: string = 'tt/record';

@Component({
  components: {JsonResource, Tag, SelfUpdatingTimeDiff, StopTimeTrackingRecordModal, LevelItem, Level}
})
export default class TimeTrackingRunningRecord extends Vue {
  public name: string = "TimeTrackingRunningRecord";

  @Action('loadUsersRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) loadUsersRunningRecord: any;

  @Getter('getRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) runningTimeTrackingRecord: any;

  private runningSinceSecs: number = 0;
  private dateNow: string = '';

  private runningTime: string = '';

  private stopTimeTrackingRecordModalActive: boolean = false;

  private get appConfig(): any {
    return AppConfig;
  }

  private get getRunningTimeTrackingRecord(): ITimeTrackingRecord | null {

    if (this.runningTimeTrackingRecord) {
      return {

        text: this.runningTimeTrackingRecord.text ?? '',
        start: this.runningTimeTrackingRecord.start ?? '',
        stop: this.runningTimeTrackingRecord.stop ?? '',
        budget: this.runningTimeTrackingRecord.budget ?? '',
        task_id: this.runningTimeTrackingRecord.task_id ?? 0,
        task: this.runningTimeTrackingRecord.task,
        client_id: this.runningTimeTrackingRecord.client_id ?? 0,
        client: this.runningTimeTrackingRecord.client,
        brand_id: this.runningTimeTrackingRecord.brand_id ?? 0,
        brand: this.runningTimeTrackingRecord.brand,
        project_id: this.runningTimeTrackingRecord.project_id ?? 0,
        project: this.runningTimeTrackingRecord.project,
        type_id: this.runningTimeTrackingRecord.type_id ?? '',
        type: this.runningTimeTrackingRecord.type,
        user_id: this.runningTimeTrackingRecord.user_id ?? 0,
        created_at: this.runningTimeTrackingRecord.created_at ?? '',
        updated_at: this.runningTimeTrackingRecord.updated_at ?? '',
        all_task_items_stats: this.runningTimeTrackingRecord.all_task_items_stats,

      };
    }

    return null;
  }

  @Watch('dateNow', {immediate: true, deep: true})
  private updateRunningTime() {

    let now: any = this.$moment();

    let runningTimeDiff: number = now.diff(this.runningTimeTrackingRecord.start);

    let runningTime: string = String(this.$moment.duration(runningTimeDiff).hours()) + ' ' + this.$tc('common_words.hours', runningTimeDiff) + ' ';
    runningTime += String(this.$moment.duration(runningTimeDiff).minutes()) + ' ' + this.$tc('common_words.minutes', runningTimeDiff) + '  ';

    this.runningTime = runningTime;

  }

  private stopTimeTrackingRecord(finished = true): void {

    this.setStopTimeTrackingRecordModalActive();

  }

  private setStopTimeTrackingRecordModalActive(): void {
    // set to false first to trigger watchers, even if window was closed before and maybe variable is still on true
    this.stopTimeTrackingRecordModalActive = false;
    this.stopTimeTrackingRecordModalActive = true;
  }

  private time(): any {

    this.dateNow = this.$moment().format(this.appConfig.DATETIME_FORMAT_FRONTEND);

  }

  private stopTimeTrackingRecordModalActiveChanged(e: any): void {

    this.stopTimeTrackingRecordModalActive = e;

  }

  private onTimeTrackingRecordStopped(record: any): void {

    this.stopTimeTrackingRecordModalActive = false;
    this.$emit('timetrackingrecord-stopped', record);

  }

  private get runningSinceString(): string {
    return 'fasdf';
  }

  private setStartTimeToNow(): void {

    let start = this.$moment().format('Y-M-D H:m:s');

  }

  /*
  private initBroadcastListener(): void {

    this.$echo.channel('TimeTracking')
        .listen('TimeTracking\\UserHasStartedNewRecord', (e) => {

          this.addRecordOnTop(e.timeTracking);

        })
    ;

  }
*/

  mounted() {

    if (!this.runningTimeTrackingRecord) {

      this.loadUsersRunningRecord({resource: RESOURCE_TIME_TRACKING_RECORD});

    }

    setInterval(this.time, 1000);

  }


}
